module.exports = __webpack_public_path__ + "static/media/kaio.2e986414.jpeg";